<template>
	<div class="icon" :class="{'icon--header':header}" :style="{height: dimension + 'px', width: dimension + 'px'}">
		<img v-if="!darkMode && !header" class="icon__background" src="@/assets/img/icon-backgrounds/bg-1.svg">
		<img v-else class="icon__background" src="@/assets/img/icon-backgrounds/bg-1-white.svg">
		<i class="icon__image" :class="icon" :style="{fontSize: 0.4 * dimension + 'px'}"></i>
	</div>
</template>

<script>
export default {
	props: {
		header: Boolean,
		icon: String,
		size: Number
	},
	data () {
		return {
		}
	},
	methods: {
	},
	computed: {
		darkMode () {
			return this.$store.state.settings.darkMode
		},
		dimension () {
			return this.size || 100
		}
	}
}
</script>

<style scoped lang="scss">
@import "@/styles/components/_icon.scss"
</style>
